import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 17,
  height: 16,
  viewboxWidth: 17,
  viewboxHeight: 16,
};

const PlusIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M8 0.5C7.7536 0.5 7.5585 0.540103 7.4058 0.597783C7.02243 0.742607 6.92377 1.15302 6.9118 1.46373C6.88537 2.14991 6.8434 3.71197 6.83487 6.83487C3.71197 6.8434 2.14991 6.88537 1.46372 6.9118C1.15302 6.92377 0.742607 7.02243 0.597783 7.4058C0.540103 7.5585 0.5 7.7536 0.5 8C0.5 8.2464 0.540103 8.4415 0.597783 8.59417C0.742607 8.97757 1.15302 9.07623 1.46372 9.0882C2.14991 9.11463 3.71197 9.1566 6.83487 9.16513C6.8434 12.288 6.88537 13.8501 6.9118 14.5363C6.92377 14.847 7.02243 15.2574 7.40583 15.4022C7.5585 15.4599 7.7536 15.5 8 15.5C8.2464 15.5 8.4415 15.4599 8.5942 15.4022C8.97757 15.2574 9.07623 14.847 9.0882 14.5363C9.11463 13.8501 9.1566 12.288 9.16513 9.16513C12.288 9.1566 13.8501 9.11463 14.5363 9.0882C14.847 9.07623 15.2574 8.97757 15.4022 8.5942C15.4599 8.4415 15.5 8.2464 15.5 8C15.5 7.7536 15.4599 7.5585 15.4022 7.40583C15.2574 7.02243 14.847 6.92377 14.5363 6.9118C13.8501 6.88537 12.288 6.8434 9.16513 6.83487C9.1566 3.71197 9.11463 2.14991 9.0882 1.46372C9.07623 1.15302 8.97757 0.742607 8.5942 0.597783C8.4415 0.540103 8.2464 0.5 8 0.5Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default PlusIcon;
